import { Card } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import { BsFillExclamationTriangleFill } from "react-icons/bs";
import FetchContext from "../../../contexts/fetch";
import FlowContext from "../../../contexts/flowContext";
import UserContext from "../../../contexts/user";
import { flowToConfig } from "../../Home/Controls/utils";
import styles from "./alloBrain.module.css";
import RequestBody from "./RequestBody";
import ObjectViewer from "../ObjectViewer";
import Summary from "./Summary";

const AlloBrain = ({ fetchStoreId, setLoading }) => {
  const [fetchState, fetchDispatcher] = useContext(FetchContext);
  const [flowState] = useContext(FlowContext);
  const [userState] = useContext(UserContext);

  const [simulation, setSimulation] = useState(null);
  const [executionId, setExecutionId] = useState(null);

  const [shouldStop, setShouldStop] = useState(false);

  // fetch simulation api
  useEffect(() => {
    /*fetchStoreId({
            processId: flowState.name
        })*/
  }, []);

  // initial store fetch
  useEffect(() => {
    setSimulation(null);
  }, [executionId]);

  useEffect(() => {
    if (
      fetchState.alloBrainSimulationResult &&
      fetchState.alloBrainSimulationResult.executionId
    ) {
      setExecutionId(fetchState.alloBrainSimulationResult.executionId);
    }
  }, [fetchState.alloBrainSimulationResult]);

  useEffect(() => {
    let interval = null;
    if (executionId) {
      if (!shouldStop) {
        setLoading(true);
        fetchLogs();
        interval = setInterval(() => {
          fetchLogs();
        }, 1000);
      } else {
        setLoading(false);
        clearInterval(interval);
      }
    }
    return () => {
      clearInterval(interval);
    };
    //setSimulation(fetchState.alloBrainSimulationResult)
  }, [executionId, shouldStop]);

  useEffect(() => {
    setLoading(fetchState.loadingSimulateFlowApi);
  }, [fetchState.loadingSimulateFlowApi]);

  useEffect(() => {
    if (fetchState.alloBrainSimulationResult) {
      try {
        setShouldStop(fetchState.alloBrainSimulationResult.store.logs.done);
      } catch (e) {
        setShouldStop(false);
      }
    }
  }, [fetchState.alloBrainSimulationResult]);

  useEffect(() => {
    if (
      fetchState.alloBrainSimulationResult &&
      fetchState.alloBrainSimulationResult.store
    ) {
      setSimulation(fetchState.alloBrainSimulationResult.store.logs);
    }
  }, [fetchState.alloBrainSimulationResult]);

  const fetchLogs = function () {
    fetchDispatcher({
      type: "fetch-allo-brain-simulate-store",
      queryParameters: {
        brand: userState.currentBrand,
        executionId: executionId,
      },
    });
  };

  const cardTitle = function (state) {
    return (
      <div className={styles.state_header}>
        <h2 className={styles.state_name}>{state.state}</h2>
        {state.logs.length ? (
          <BsFillExclamationTriangleFill className={styles.failed_state_mark} />
        ) : (
          <AiFillCheckCircle className={styles.validated_state_mark} />
        )}
      </div>
    );
  };

  const launchSimulation = function (bodyRequest) {
    fetchStoreId(
      null,
      {
        //processId: flowState.name
        flowId: flowState._id,
        brand: userState.currentBrand,
      },
      {
        processBody: bodyRequest,
        config: flowToConfig(
          flowState,
          userState.currentApp,
          fetchState.clientConfig.edge
        ),
      }
    );
  };

  return simulation && !fetchState.loadingSimulateFlowApi ? (
    <div className={styles.simulation_container}>
      <Summary states={simulation.states} />

      <div className={styles.body}>
        {simulation.states.length &&
          simulation.states.map((state, index) => (
            <Card
              key={index}
              className={`${styles.state} ${
                state.logs.length ? styles.failed_state : styles.validated_state
              }`}
              title={cardTitle(state)}
              bordered={false}
            >
              {state.logs.length > 0 && (
                <div>
                  <div>
                    <span>Error: </span>
                    <span>{JSON.stringify(state.logs[0])}</span>
                  </div>
                  <div>
                    <span>Type: </span>
                    <span>
                      {state.logs[1].error
                        ? state.logs[1].error.Error
                        : JSON.stringify(state.logs[1])}
                    </span>
                  </div>
                  <div>
                    <span>Message: </span>
                    <span>
                      {state.logs[1].error
                        ? JSON.parse(state.logs[1].error.Cause).errorMessage
                        : JSON.stringify(state.logs[1])}
                    </span>
                  </div>
                </div>
              )}

              <ObjectViewer object={state.store} title="Store Snapshot" />

              <div className={styles.state_timestamp}>
                <span>{new Date(state.timestamp * 1000).toString()}</span>
              </div>
            </Card>
          ))}
        {!simulation.states.length && (
          <div className={styles.no_data_container}>
            <h2>No data...</h2>
          </div>
        )}
      </div>
    </div>
  ) : fetchState.simulationError ? (
    <div className={styles.simulation_container}>
      <div className={styles.error_message}>
        <span>
          <BsFillExclamationTriangleFill className={styles.failed_state_mark} />
        </span>
        <span>
          error {JSON.stringify(fetchState.simulationError)}
          {fetchState.simulationError.message}
        </span>
      </div>
    </div>
  ) : (
    <RequestBody launchSimulation={launchSimulation} />
  );
};

export default AlloBrain;
